var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4888 7.77063C15.8349 8.69932 13.9668 11.48 13.9668 12.9493C13.9668 14.3148 15.0969 15.426 16.4857 15.426C17.89 15.426 19.0327 14.315 19.0327 12.9493C19.0327 11.4255 17.1505 8.68638 16.4888 7.77063Z",
    fill: "#5E667A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_4733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C9 13 7.59022 15.107 3.75 14.0234C3.14281 13.8521 2.25 13.5 2.25 13.5M14.25 8.47658C10.4098 7.39304 7.59022 10.607 3.75 9.52343C3.14281 9.35213 2.25 9 2.25 9M15.75 4.5C15.75 4.5 14.8572 4.14786 14.25 3.97655C10.4098 2.89304 7.59022 6.10696 3.75 5.02346C3.14281 4.85214 2.25 4.5 2.25 4.5",
    stroke: "#5E667A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-261.302 -52.4067C-279.079 -14.0767 -289 28.6367 -289 73.6667C-289 122.617 -277.277 168.827 -256.484 209.647C-246.387 229.47 -225.129 240.333 -202.883 240.333H224.883C247.13 240.333 268.387 229.47 278.483 209.647C299.277 168.827 311 122.617 311 73.6667C311 -92.0187 176.687 -226.333 11 -226.333C-33.1033 -226.333 -74.9847 -216.816 -112.701 -199.724M-12.57 50.1C0.446659 37.0833 21.5533 37.0833 34.57 50.1C47.5867 63.1167 47.5867 84.2233 34.57 97.24C21.5533 110.26 0.446659 110.26 -12.57 97.24C-25.5867 84.2233 -25.5867 63.1167 -12.57 50.1ZM-12.57 50.1L-224.702 -162.032",
    stroke: "black",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_4733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.e5630f0c692ceee4f3fffc23d4c030c8.svg";
export { ForwardRef as ReactComponent };